module.exports = __webpack_public_path__ + "media/app-store-detail/SoftwareAdvice_white-234f0eba.png";